import React from 'react';
import { UserModel } from '../../../../../interfaces/user.interface';
import { BookModel } from '../../../../../interfaces/book.interface';
import { ListViewMode } from '../../ListViewModeSwitcher';
import { useStorageObjectUrl } from '../../../../../services/file.service';

interface BookCoverDisplayProps {
  mode: ListViewMode;
  bookData: BookModel;
  user: UserModel | null;
  editCover: boolean;
  setShowBookCover: (data: boolean) => void;
  showBookCover: (data: boolean) => void;
  stateData: any;
  setStateData: React.Dispatch<React.SetStateAction<any>>;
}

const BookCoverDisplay: React.FC<BookCoverDisplayProps> = ({
                                                             mode,
                                                             bookData,
                                                             user,
                                                             editCover,
                                                             showBookCover,
                                                             setShowBookCover,
                                                             stateData,
                                                             setStateData
                                                           }) => {
  const { url: coverImageURL, loading, error } = useStorageObjectUrl(bookData?.coverURL);

  return (
    <div
      className={` flex flex-col justify-center items-start gap-[1rem] lg:gap-2  mx-auto rounded xs:flex-wrap ${mode === ListViewMode.GRID ? ' md:flex-row' : 'flex-col '
      }  py-4 mx-0 md:mx-2 `}
    >
      <div
        className={` flex flex-col items-center gap-[1rem] lg:gap-2 ${mode === ListViewMode.GRID ? 'mx-0 lg:mx-auto' : 'ml-[2.5rem] mr-[0.5rem] lg:mx-auto'
        }`}
      >
        <div
          className={`rounded-lg ${mode === ListViewMode.PAGE ? 'h-[350px] w-[350px] md:w-[600px] md:h-[600px]' : ' h-[18rem] w-[18rem]'
          }    flex justify-center items-center relative`}
        >
          <div
            className="absolute h-full w-full grayscale rounded"
            style={{
              backgroundImage: `url('${bookData?.coverURL ? coverImageURL || bookData?.coverURL : '/texture.png'}')`,
              backgroundSize: 'cover'
            }}
          ></div>
          <div
            className={` ${mode === ListViewMode.PAGE
              ? 'h-[320px] w-[270px] pt-[1rem] md:w-[460px] md:h-[530px] md:pt-[2rem]'
              : 'h-[16rem] w-[14rem] pt-[1rem]'
            }    rounded flex justify-center`}
            style={{
              backgroundImage: `url('${'/texture.png'}')`,
              backgroundSize: 'cover',
              zIndex: 1
            }}
          >
            <div
              className={` ${mode === ListViewMode.PAGE ? 'w-[14rem] h-[14rem] md:w-[400px] md:h-[400px]' : 'h-[12rem] w-[12rem]'
              }  flex justify-center items-center relative rounded`}
              style={{
                backgroundImage: `url('${coverImageURL || bookData?.coverURL}')`,
                backgroundSize:
                  mode === ListViewMode.GRID
                    ? '288px'
                    : mode === ListViewMode.PAGE && window.innerWidth < 768
                      ? '350px'
                      : '600px',
                backgroundPosition: mode === ListViewMode.GRID ? '50% 33.4%' : '50% 33.4%',
                backgroundRepeat: 'no-repeat'
              }}
            >
              <div
                className={` ${mode === ListViewMode.PAGE
                  ? 'top-[9.5rem] sm:gap-2 sm:top-[9.5rem]  md:top-[15.5rem]'
                  : 'top-[122px] '
                } relative flex flex-col items-center `}
              >
                <h1
                  className={` ${mode === ListViewMode.PAGE ? 'text-md  md:text-2xl' : 'leading-[15px] '
                  }  flex justify-center items-center text-center font-yuji-boku`}
                >
                  {bookData?.title}
                </h1>
                <h1
                  className={` ${mode === ListViewMode.PAGE ? ' text-[10px] md:text-lg ' : ' text-[10px] '
                  } font-poppins text-[10px] text-gray-600 mb-1`}
                >
                  by {bookData?.authorName ? bookData?.authorName : `${user?.firstName} ${user?.lastName}`}
                </h1>
              </div>
            </div>
          </div>
        </div>
        {editCover && (
          <button
            className="bg-storyblueSecondLightText flex  text-white font-sans rounded-2xl px-4 py-2 text-xs "
            onClick={() => {
              setShowBookCover(!showBookCover);
              setStateData({ ...stateData, showDownloadPDF: false });
            }}
          >
            Edit Cover
          </button>
        )}
      </div>
      <div
        className={` ${mode === ListViewMode.GRID ? 'h-72 w-72' : 'w-[350px] h-[350px] md:w-[600px] md:h-[600px]'
        } flex justify-center items-center rounded-lg test ${mode === ListViewMode.GRID ? '' : 'ml-[2.5rem] lg:mx-auto'
        } bg-white`}
      >
        <p className={` ${mode === ListViewMode.GRID ? 'm-4' : 'm-12 md:m-40'} m-4 text-gray-500 text-base`}>
          This page is Intentionally left blank
        </p>
      </div>
    </div>
  );
};

export default BookCoverDisplay;
